/**
 * NProgress 路由进度条配置
 * @description 页面切换时显示顶部进度条，提升用户体验
 */

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// 配置 NProgress
NProgress.configure({
  // 动画速度
  speed: 400,
  // 是否显示加载ico
  showSpinner: false,
  // 自动递增间隔
  trickleSpeed: 200,
  // 初始化时的最小百分比
  minimum: 0.3,
})

/**
 * 开始进度条
 */
export function startProgress() {
  NProgress.start()
}

/**
 * 结束进度条
 */
export function doneProgress() {
  NProgress.done()
}

/**
 * 设置进度
 */
export function setProgress(n: number) {
  NProgress.set(n)
}

/**
 * 进度条递增
 */
export function incProgress() {
  NProgress.inc()
}

export default NProgress
